import React, { useState } from "react";
import Dropdown from "../Dropdown/Dropdown";
import Header from "../Header/Header";
function Hero() {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
      <Dropdown isOpen={isOpen} toggle={toggle} />
      <Header toggle={toggle} />

      <main>
        <div className="Container">
        <div className="straight-line-content">
          {/* Hero Section */}
          <section className="hero-section">
            <div className="content-wrapper">
              <h1 className="shake-text">Hi, I'm Yobah John</h1>
              <h5 className="moving-text">Software Engineer | Full Stack Developer | Graphic Designer | IT Specialist, IT Consultant</h5>
            <p>
              <strong className="professional-summary-title">Professional Summary</strong><br/>
              Software Developer (Full-Stack) with a strong background in designing and building dynamic, scalable web applications using Linux, Apache, MySQL, PHP, and NoSQL databases such as MongoDB. Highly skilled in modern frontend technologies including React.js, Next.js, JavaScript, HTML5, and CSS3, alongside robust backend development and seamless API integration. A strong advocate for clean, maintainable code, UI/UX best practices, and mobile-first, responsive design. Passionate about creating impactful digital platforms that serve real people and solve local, real-world problems.
            </p>
            </div>
          </section>






        </div>
      </div>
    </main>
    </>
  );
}

export default Hero;
